import Form from 'Components/Forms/FormGenerator';
import FormViewer from 'Components/FormViewer';
import { actions as deviceActions } from 'ducks/devices';
import { actions as measurementActions } from 'ducks/measurements';
import { sortBy } from 'lodash';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { metadataFields, serializeForm } from 'utils/forms/utils';
import validators from 'utils/forms/validators';
import { getDeviceMetadata } from 'utils/getMetadata.js';

const maxDelayOptions = [
    { id: 14400, name: '4h' },
    { id: 28800, name: '8h' },
    { id: 86400, name: '24h' },
    { id: 172800, name: '48h' }
];

const Component = props => {
    const { installationZones } = props;
    const { closeDrawer } = props;

    const device = useSelector(state => state.devices.models[props.id]);
    const submitting = useSelector(state => state.devices.submitting);

    const equipment = useSelector(state => state.equipments.models[device.equipment_id]);
    const rootDevice = useSelector(state => state.devices.models[device.root_device_id]);
    const metadata = getDeviceMetadata(equipment, rootDevice);

    let formSchema = [
        {
            type: 'text',
            label: 'Name\x2a',
            name: 'name',
            validate: [validators.required]
        },
        {
            formData: sortBy(installationZones, 'full_path').map(({ id, full_path }) => ({ id, name: full_path })),
            label: 'Installation Zone\x2a',
            name: 'installation_zone_id',
            type: 'select',
            validate: [validators.required]
        },
        {
            type: 'textArea',
            label: 'Description',
            name: 'description',
            rows: 8
        },
        {
            type: 'select',
            label: 'Maximum Allowed Delay',
            name: 'max_delay',
            formData: maxDelayOptions
        },
        {
            label: 'Integration?',
            name: 'integration',
            type: 'checkBox'
        }
    ];

    formSchema.push(...metadataFields(metadata, device));

    const dispatch = useDispatch();
    const { fetchDevice, fetchMeasurements, update } = ({
        fetchDevice: id => dispatch(deviceActions.fetchOne(id)),
        fetchMeasurements: measurementActions.useFetchAll(),
        update: deviceActions.useUpdate()
    });

    useEffect(() => {
        fetchDevice(device.id);
    }, [device.id, fetchDevice]);

    const onSubmit = values => update(
        device.id,
        serializeForm(values, formSchema, device),
        () => {
            fetchMeasurements({ device_id: device.id }, null);
            closeDrawer();
        }
    );

    return (
        <FormViewer label="Edit Device">
            <Form
                formInitialValues={device}
                formSchema={formSchema}
                isSubmitting={submitting}
                onSubmit={onSubmit}
            />
        </FormViewer>
    );
};

export default Component;
